import { FETCH_RUTAS, GET_RUTAS, SET_RUTA_REPARTO } from "../actions/types.js";

const initialState = {
  rutas: [],
  ruta: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_RUTAS:
      return {
        ...state,
        rutas: [],
        ruta: {},
        isLoading: true,
      };
    case GET_RUTAS:
      return {
        ...state,
        rutas: action.payload,
        isLoading: false,
      };
    case SET_RUTA_REPARTO:
      return {
        ...state,
        ruta: action.payload,
      };
    default:
      return state;
  }
}
